const Form043TC = {
    stepName: {
        statement: "重要事項",
        essentialInfo: "基本資料",
        segmentInfo: "分部資料",
        confirmation: "確認",
    },
    deadlineTip: "此表格已過期，不能提交",
    label: {
        title: {
            tips: "基本資料",
            tipsOne: "幼稚園名稱",
            tipsTwo: "核准容額總數",
        },
        tips: {
            am: "上午班",
            pm: "下午班",
            fullday: "全日班",
        },
        kindergartenName: "幼稚園名稱",
        childCareCenterName: "幼兒中心名稱",
        classroomNumber: "註冊課室總數（如適用）",
        classroomPlacesNumber: "課室核准學額總數（如適用，請參閱容額證明書）",
        halfDaySystem: "半日制",
        fullTime: "全日制",
        morningFieldA: "零至二歲",
        morningFieldB: "二至三歲",
        morningFieldC: "三至六歲",
        morningFieldD: "二至六歲",
        afternoonFieldA: "零至二歲",
        afternoonFieldB: "二至三歲",
        afternoonFieldC: "三至六歲",
        afternoonFieldD: "二至六歲",
        fullTimeFieldA: "零至二歲",
        fullTimeFieldB: "二至三歲",
        fullTimeFieldC: "三至六歲",
        fullTimeFieldD: "二至六歲",
        code: {
            kindergartenName: "幼稚園",
            childCareCenterName: "幼兒中心",
        },
    },
    label2: {
        title: {
            tips: "分部資料",
            tipsD: "已取錄學生／兒童人數",
            tipsThree: "聯絡方法",
        },
        tips: {
            tipsA: "上午",
            tipsB: "下午",
            tipsC: "全日",
        },
        tips2: {
            tipsC: "K1",
            tipsD: "K2 ",
            tipsE: "K3",
            tipsA: "2歲以下組",
            tipsB: "2-3歲組",
        },
        note: {
            note1: "如有查詢請致電",
            note2: "與",
            note3: "聯絡。",
        },
        signType: {
            supervisor: "校監",
            schoolHead: "校長",
        },
        segmentInformation: "分部（上午／下午／全日）",
        kGClassOrGroup: "幼稚園班級／幼兒中心年齡組別",
        classroomName: "課室名稱（如適用）（例如1, 2／A, B）",
        classroomApproval: "課室核准學額（如適用）（請參閱容額證明書）",
        childrenEnrolled: "已取錄學生／兒童人數",
        remarks: "備註",
        aMSubtotal: "上午班小計",
        pMSubtotal: "下午班小計",
        wDSubtotal: "全日班小計",
        total: "總計",
        conditionsCheck: "本人確認上述資料並無遺漏，全屬真確",
        contacts: "聯絡人",
        signInfo: "簽署信息",
        signPerson: "校監／校長",
        signPersonName: "校監／校長姓名",
    },
    label1: {
        header: {
            headerOne: "填表須知",
        },
        importantNote1: "請於每年{{deadline}}前交回",
        // importantNote2: "(以{{asAtDate}}的收錄情況為準)",
        // content: "請於{{date}}前交回。",
        statement: "本人已閱讀、明白及同意上述條款及細則。",
        statement1:
            "本人理解申請人和學校審批人需要擁有「智方便+」帳戶才能處理申請。",
    },
    errorMsg: {
        required: "此字段必填",
        total: "核准容額總數必須大於0",
        note: "幼稚園名稱／幼兒中心名稱必須填寫其中一個",
        note2: "不得超過200字符／中文不超過30字符",
        note3: "請輸入正確的內容",
        note4: "已取錄學生／兒童人數大於課室核准學額，請具體説明",
        note5: "如不適用, 請輸入N/A",
    },
};
export default Form043TC;
